import { render, staticRenderFns } from "./CreateAccountMobile.vue?vue&type=template&id=70efa4fe&scoped=true"
import script from "./CreateAccountMobile.vue?vue&type=script&lang=js"
export * from "./CreateAccountMobile.vue?vue&type=script&lang=js"
import style0 from "./CreateAccountMobile.vue?vue&type=style&index=0&id=70efa4fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70efa4fe",
  null
  
)

export default component.exports